import { lazy } from "react";

export default lazy(() =>
  import(
    /* webpackChunkName: "InstantSearch" */
    "./InstantSearch.component"
  )
);
